<template>
  <div class="sign-in">
    <form novalidate test-id="form" @submit.prevent="syncLogin">
      <div class="upper">
        <h1>Welcome Back</h1>
        <p>Please enter your details below</p>
        <div class="fields">
          <LsInput
            v-model="email"
            name="email"
            track-id="sign_in_view-email"
            placeholder="Email Address"
            type="email"
            :validation="{ required: true, email: true }"
          />
          <LsInput
            v-model="password"
            name="password"
            track-id="sign_in_view-password"
            placeholder="Password"
            type="password"
            :validation="{ required: true, min: isLawnStarter ? 6 : 1 }"
            class="ls-input"
          />
        </div>
      </div>

      <div class="middle">
        <RouterLink :to="{ name: 'passwordRecovery' }" class="forgot-pw" test-id="forgot_link"
          >Forget your password?</RouterLink
        >

        <LsButton
          text="sign in"
          track-id="sign_in_view-sign_in"
          test-id="sign_in"
          type="submit"
          :loading="auth.loadingStatus.isLoading"
        />
      </div>
      <div class="bottom">
        <span class="has-text-weight-bold not-registered">Not registered?</span>

        <a :href="signUpUrl" class="signup-link">Sign up and order service</a>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { AUTH__SYNC_LOGIN } from '@/store/types';
import { LsButton, LsInput } from '@/components/common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LoginView',
  components: {
    LsButton,
    LsInput,
  },
  $_veeValidate: {
    validator: 'new',
  },
  mixins: [themedComponentMixin],
  data() {
    return {
      email: '',
      password: '',
      signUpUrl: process.env.VUE_APP_SIGNUP_BASE_URL,
    };
  },
  computed: {
    ...mapState(['auth']),
  },
  methods: {
    ...mapActions([AUTH__SYNC_LOGIN]),
    async syncLogin() {
      const valid = await this.$validator.validateAll();
      if (!valid) {
        return;
      }

      this[AUTH__SYNC_LOGIN]({ email: this.email, password: this.password });
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  color: $primary;
  padding: 10px 0;
}

.fields {
  padding-top: 15px;
}

.ls-input {
  margin: 6px 0 6px 0;
}

.middle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid $primary-light;
  padding: 24px 0;
}

.forgot-pw {
  color: $primary;
  font-size: $size-4;
  padding: 10px 0;
  &:hover {
    color: $special-primary-hover;
  }
}

.bottom {
  color: $primary;
  padding-top: 46px;
  display: flex;
  justify-content: center;
}

.not-registered {
  padding-right: 4px;
}

.signup-link,
a {
  color: $primary;
  &:hover {
    color: $special-primary-hover;
  }
}

@media (max-width: $mobile-max-width) {
  .upper {
    padding-top: 10px;
  }

  p,
  h1 {
    text-align: center;
  }

  .middle {
    display: flex;
    flex-direction: column;
  }

  .forgot-pw {
    padding: 0 0 20px 0;
    font-size: $size-6;
  }

  .bottom {
    padding-top: 32px;
  }
}

.themed-app {
  p,
  .bottom {
    color: $theme-color-primary;
  }

  .forgot-pw,
  .signup-link,
  a {
    color: $theme-color-primary;

    &:hover {
      opacity: 0.65;
    }

    &:hover .chevron {
      opacity: 1;
    }
  }

  .middle {
    border-color: $theme-color-primary-light;
  }
}
</style>
